const transitions = {
  fast: '200ms',
  fast_50: '50ms',
  medium: '350ms'
};

export default transitions;
